import React from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import SMCLabel from '../../../../components/Simple/SMCLabel';
import firewallIcon from '../../../../assets/images/firewall_16.png';
import appControl from '../../../../assets/images/app_control_16.png';
import urlFiltering from '../../../../assets/images/url_filtering.png';
import ida from '../../../../assets/images/ida_16.png';
import qos from '../../../../assets/images/qos_16.png';
import ips from '../../../../assets/images/ips_16.png';
import antiVirus from '../../../../assets/images/anti_virus_16.png';
import antiBot from '../../../../assets/images/anti_bot_16.png';
import threatEmulation from '../../../../assets/images/threat_emulation_16.png';
import antiSpam from '../../../../assets/images/anti_spam_16.png';
import vpnSite from '../../../../assets/images/vpn_site_16.png';
import licenseBrown from '../../../../assets/images/license_brown_16.png';
import SMCTable from '../../../../components/core/SMCTable/SMCTable';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import RowLayout from '../../../../components/Layouts/RowLayout';

const pageSchema = GatewayGetSchema.pages.gatewayBladesLicenses;
const pageId = pageSchema.pageId;

function GatewayGatewayBladesLicenses({
    gatewayObject
}) {

    const pageData = gatewayObject[pageId];
    
    const licenseItemList = pageData[pageSchema.licenseItemList];
    const licenseItemListSchema = pageSchema.licenseItemListSchema;
    const nameCell = ({value, object, index}) => {
        switch(value) {
            case 'Firewall':
                return <span><RowLayout spacing="4px"><img src={firewallIcon} alt="" /> Firewall</RowLayout></span>;
            case 'Application Control':
                return <span><RowLayout spacing="4px"><img src={appControl} alt="" /> Application Control</RowLayout></span>;
            case 'URL Filtering':
                return <span><RowLayout spacing="4px"><img src={urlFiltering} alt="" /> URL Filtering</RowLayout></span>;
            case 'Identity Awareness':
                return <span><RowLayout spacing="4px"><img src={ida} alt="" /> Identity Awareness</RowLayout></span>;
            case 'Advanced Networking':
                return <span><RowLayout spacing="4px"><img src={qos} alt="" /> Advanced Networking</RowLayout></span>;
            case 'IPS':
                return <span><RowLayout spacing="4px"><img src={ips} alt="" /> IPS</RowLayout></span>;
            case 'Anti-Virus':
                return <span><RowLayout spacing="4px"><img src={antiVirus} alt="" /> Anti-Virus</RowLayout></span>;
            case 'Anti-Bot':
                return <span><RowLayout spacing="4px"><img src={antiBot} alt="" /> Anti-Bot</RowLayout></span>;
            case 'Threat Emulation':
                return <span><RowLayout spacing="4px"><img src={threatEmulation} alt="" /> Threat Emulation</RowLayout></span>;
            case 'Anti-Spam':
                return <span><RowLayout spacing="4px"><img src={antiSpam} alt="" /> Anti-Spam</RowLayout></span>;
            case 'IPSec VPN':
                return <span><RowLayout spacing="4px"><img src={vpnSite} alt="" /> IPSec VPN</RowLayout></span>;
            default:
                return null;
        }
    }

    const expirationCell = ({value, object, index}) => {
        if(value) {
            return <span><RowLayout spacing="4px"><img src={licenseBrown} alt="" /> {value}</RowLayout></span>;
        }
        else {
            return null;
        }
    }

    const columns = [
        { id: 'name', Cell: nameCell, accessor: licenseItemListSchema.name, header: 'Name', width: 170 },
        { id: 'expiration', Cell:expirationCell, accessor: licenseItemListSchema.expiration, header: 'Expiration', width: 170 },
        { id: 'service', accessor: licenseItemListSchema.service, header: 'Service', width: 170 }
    ]

    return (
        <EditorLayout>
            <SMCLabel bold>Software Blades Licenses</SMCLabel>
            <SMCTable
                columns={columns}
                content={licenseItemList}
                hasCheckboxColumn={false}
            />
            <SMCLabel><b>Notes: </b>The licenses table will be updated within 24 hours</SMCLabel>
        </EditorLayout>
    );
}

export default GatewayGatewayBladesLicenses;